/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActivityChannelOrientationConfiguration } from './activityChannelOrientationConfiguration';
import { ShareDto } from './shareDto';
import { ParameterData } from './parameterData';
import { RequestedShare } from './requestedShare';


export interface DeviceDto { 
    id?: number;
    label?: string;
    role?: DeviceDto.RoleEnum;
    shares?: Array<ShareDto>;
    requestedShares?: Array<RequestedShare>;
    name: string;
    description?: string;
    deviceTypeId?: string;
    deviceTypeCustomerName?: string;
    deviceTypeActivityChannelOrientations?: ActivityChannelOrientationConfiguration;
    parameterDataList?: Array<ParameterData>;
    firmwareVersionId?: string;
    bootloaderVersionId?: string;
    updateTs?: string;
    pcbTypeId?: string;
    nfcTagUid?: string;
}
export namespace DeviceDto {
    export const RoleEnum = {
        Reader: 'READER',
        DataManager: 'DATA_MANAGER',
        Owner: 'OWNER',
        DeviceManager: 'DEVICE_MANAGER'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
}


